import { Component, Input } from '@angular/core';
import { ContextService } from 'app/back-office/shared/services/core/context.service';
import { Shop } from 'app/shared/models/shop.model';

@Component({
  selector: 'app-work-in-progress',
  templateUrl: './work-in-progress.component.html',
  styleUrls: ['./work-in-progress.component.scss']
})
export class WorkInProgressComponent {
  currentShop: Shop;
  @Input() disableWelcome = false;
  @Input() subTitle;
  @Input() small;
  constructor(private _context: ContextService) {
    this._context.currentShop.subscribe(data => this.currentShop = data);
  }
}
